import { formatDateTime, formatShortDate } from "@/utils/format";
import { getDocOption } from "./build-submission-payload";
/** Resolves a field value to a human-readable label (dropdown label or formatted date), else raw. */
function displayValue(field, value, config) {
  if (field.type === "dropdown" && field.options_ref) {
    var _config$dropdowns$fie;
    var match = ((_config$dropdowns$fie = config.dropdowns[field.options_ref]) !== null && _config$dropdowns$fie !== void 0 ? _config$dropdowns$fie : []).find(function (item) {
      return item.value === value;
    });
    if (match) return match.label;
  }
  if (field.type === "datetime") return formatDateTime(value);
  if (field.type === "date") return formatShortDate(value);
  return value;
}

/** Builds the encounter review summary rows from filled fields. */
export function buildEncounterSummary(config, formData) {
  if (!config) return [];
  return config.fields.filter(function (field) {
    return Boolean(formData[field.name]);
  }).map(function (field) {
    return {
      label: field.label,
      value: displayValue(field, formData[field.name], config)
    };
  });
}

/** Builds the document review summary rows for the selected document kind. */
export function buildDocSummary(config, docKind, formData) {
  var _option$fields;
  var option = getDocOption(config, docKind);
  if (!option || !config || !docKind) return [];
  return ((_option$fields = option.fields) !== null && _option$fields !== void 0 ? _option$fields : []).filter(function (field) {
    return field.type !== "dynamic";
  }).filter(function (field) {
    return Boolean(formData["".concat(docKind, ".").concat(field.name)]);
  }).map(function (field) {
    return {
      label: field.label,
      value: field.type === "file_upload" ? "Attached file" : displayValue(field, formData["".concat(docKind, ".").concat(field.name)], config)
    };
  });
}